import { Language, User } from '@/definitions';
import {
  CheckRegistrationValid,
  FirebaseCustomToken,
  FirebaseCustomTokenResponse,
} from '@/definitions/Auth';
import {
  CheckEmailRegistrationResponse,
  UserApiResponse,
  UserInfo,
  UserInfoResponse,
} from './types';

export const checkRegistrationAdapter = (
  data: CheckEmailRegistrationResponse,
): CheckRegistrationValid => {
  return {
    status: data.status,
    isAllowed: data.is_allowed,
    message: data.message,
    reason: data.reason,
  };
};

export const firebaseCustomTokenAdapter = (
  data: FirebaseCustomTokenResponse,
): FirebaseCustomToken => {
  return {
    nextUrl: data.next_url,
    firebaseCustomToken: data.firebase_custom_token,
  };
};

export const userAdapter = (data: UserApiResponse): User => {
  return {
    id: data.id,
    email: data.email,
    firstName: data.firstname,
    lastName: data.lastname,
    settings: {
      language: data.settings.language as Language,
      exerciseExecutionMode: data.settings.exercise_execution_mode,
      aiEnabled: data.settings.ai_enabled,
      aiModelSize: data.settings.ai_model_size,
      audioEnabled: data.settings.audio_enabled,
    },
  };
};

export const userInfoAdapter = (user: UserInfoResponse): UserInfo => {
  return {
    uuid: user.uuid,
    lastName: user.lastname,
    firstName: user.firstname,
    email: user.email,
  };
};
